import React from 'react'
import styled from 'styled-components'
import { colors, spacing, body, typographyMixin, mediaQuery } from 'src/constants/marketing-ds'

const AllChannelsFooter = ({ lang, market, channels }) => {
  return (
    <StyledAllChannelsFooter>
      <FooterContent>
        <ChannelLogosGrid channelCount={channels.length}>
          {channels.map((channel) => (
            <TryNowLink
              key={channel.id}
              href={channel.ctaLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LogoBox>
                <LogoImage src={channel.logo} alt={channel.name} />
              </LogoBox>
              <LinkText>{channel.ctaTextShort || 'Try now'}</LinkText>
            </TryNowLink>
          ))}
        </ChannelLogosGrid>
      </FooterContent>
    </StyledAllChannelsFooter>
  )
}

export default AllChannelsFooter

const StyledAllChannelsFooter = styled.footer`
  width: 100%;
  box-sizing: border-box;
  background-color: ${colors.black};
  padding: ${spacing.xxxxl} ${spacing.lg};
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaQuery.tablet} {
    padding: ${spacing.xxxxl} ${spacing.xl};
  }

  ${mediaQuery.desktop} {
    padding: ${spacing.xxxxl} ${spacing.xxl};
  }
`

const FooterContent = styled.div`
  width: 100%;
  max-width: 1000px;
`

const ChannelLogosGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${spacing.xl} ${spacing.lg};

  ${mediaQuery.tablet} {
    gap: ${spacing.xxl} ${spacing.sm};
  }

  ${mediaQuery.desktop} {
    gap: ${spacing.xl};
  }
`

const TryNowLink = styled.a`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xxxs};
  align-items: center;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  flex: 0 0 calc(50% - ${spacing.xl});
  min-width: 130px;

  ${mediaQuery.tablet} {
    flex: 0 0 calc(33.333% - ${spacing.sm});
  }

  ${mediaQuery.desktop} {
    flex: 0 0 calc(20% - ${spacing.xl});
  }
`

const LogoBox = styled.div`
  width: 100%;
  max-width: 150px;
  margin: 0 auto;
  box-sizing: border-box;
  aspect-ratio: 1;
  background-color: ${colors.slate[60]};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.sm};
  transition: background-color 0.2s ease;
`

const LogoImage = styled.img`
  max-width: 90%;
  max-height: 70%;
  object-fit: contain;
  display: block;
`

const LinkText = styled.span`
  ${typographyMixin(body.md)};
  color: ${colors.slate[100]};
  text-decoration: underline;
  text-decoration-style: solid;
  text-underline-offset: 4px;
  cursor: pointer;
  transition: color 0.2s ease;
`
